import React from 'react';
import PropTypes from 'prop-types';
import { EmotionBreakpoint } from 'dw-us-ui';
import styled from '@emotion/styled';

const props = {
  srcMob: PropTypes.string,
  alt: PropTypes.string.isRequired,
  src: PropTypes.string,
  brand: PropTypes.string,
};

const defaultProps = {
  brand: 'law',
  src: '',
  srcMob: '',
};

const MediaContainer = styled.div`
  ${EmotionBreakpoint('notDesktop')} {
    .infoBlockMediaContainer {
      .embed-responsive-item {
        height: 250px;
      }
    }
  }
`;
const Media = ({ alt, src, brand, srcMob }) => (
  <MediaContainer className={`p-0 imageWrapper ${brand} cms`}>
    <picture>
      <source media="(max-width: 768px)" srcset={srcMob || src} />
      <img className="image" alt={alt} src={src} width={'100%'} />
    </picture>
  </MediaContainer>
);

Media.propTypes = props;
Media.defaultProps = defaultProps;

export { Media };
